"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _idBlockchainUtils = require("3id-blockchain-utils");

var _caip = require("caip");

var _abstractAuthProvider = _interopRequireDefault(require("./abstractAuthProvider"));

var _errors = require("../errors");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// TODO get network from provider
var chainId = 'eip155:1';
/**
 *  AuthProvider which can be used for ethreum providers with standard interface
 */

var EthereumAuthProvider = /*#__PURE__*/function (_AbstractAuthProvider) {
  (0, _inherits2["default"])(EthereumAuthProvider, _AbstractAuthProvider);

  var _super = _createSuper(EthereumAuthProvider);

  function EthereumAuthProvider(ethProvider, address) {
    var _this;

    (0, _classCallCheck2["default"])(this, EthereumAuthProvider);

    _errors.assert.isDefined(ethProvider, 'Missing Ethereum provider');

    _errors.assert.isString(address, 'Address must be a string');

    _this = _super.call(this, 'ethereum');
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "accountId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "address", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "provider", void 0);
    _this.provider = ethProvider;
    _this.address = address;
    _this.accountId = _this._toAccoundId(address);
    return _this;
  }

  (0, _createClass2["default"])(EthereumAuthProvider, [{
    key: "_toAccoundId",
    value: function _toAccoundId(address) {
      return new _caip.AccountID({
        address: address,
        chainId: chainId
      }).toString();
    }
  }, {
    key: "authenticate",
    value: function () {
      var _authenticate2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(message, address) {
        var accountId;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _errors.assert.isString(message, 'Message must be a string');

                accountId = address ? this._toAccoundId(address) : this.accountId; // @ts-ignore wrong definition in 3id-blockchain-utils?

                _context.next = 4;
                return (0, _idBlockchainUtils.authenticate)(message, accountId, this.provider);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function authenticate(_x, _x2) {
        return _authenticate2.apply(this, arguments);
      }

      return authenticate;
    }()
  }, {
    key: "createLink",
    value: function () {
      var _createLink2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(did, address) {
        var accountId;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _errors.assert.isString(did, 'DID must be a string');

                accountId = address ? this._toAccoundId(address) : this.accountId; // @ts-ignore wrong definition in 3id-blockchain-utils?

                return _context2.abrupt("return", (0, _idBlockchainUtils.createLink)(did, accountId, this.provider, {
                  type: 'ethereum-eoa'
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createLink(_x3, _x4) {
        return _createLink2.apply(this, arguments);
      }

      return createLink;
    }()
  }]);
  return EthereumAuthProvider;
}(_abstractAuthProvider["default"]);

var _default = EthereumAuthProvider;
exports["default"] = _default;